<template>
  <div class="container">
    <div class="layout gap-2" selenium="pro-account-invite-a-pro">
      <div class="layout-item is-12 text-center text-left:t">
        <h2>
          Invite a Pro
        </h2>
      </div>
      <div class="layout-item is-12 is-4:t">
        <div class="d-flex jc-center jc-start:t">
          <img :src="$options.IMAGE.image" class="IMAGE"/>
        </div>
      </div>
      <div class="layout-item is-12 is-8:t p-y-4">
        <h3 class="m-b-0 d-block:t d-none">Enjoying Pro Referral?</h3>
        <h3 class="m-b-0 d-none:t text-center text-left:t">Are you enjoying Pro Referral?</h3>
        <p clasS="m-b-2 text-center text-left:t">
          Invite other Pros to Pro Referral with the link below!
        </p>
        <div class="layout gap-2:t">
          <div class="layout-item is-8">
            <div class="input-container">
              <input
                  v-vk-input
                  type="text"
                  class="input"
                  readonly
                  :value="referenceUrl"
                  v-on:dblclick="copy"
              >
            </div>
          </div>
          <div class="layout-item is-4">
            <button
                :class="copied ? 'COPY-BUTTON' : ''"
                class="btn w-100"
                type="button"
                @click="copy">
              {{ copied ? 'Link Copied!' : 'Copy Link'}}
            </button>
          </div>
        </div>
        <div class="d-none d-block:t">
          <h3 class="m-b-0">Share</h3>
          <p class="m-b-2">
            Invite the Pros you know via email or your preferred social media account
          </p>
        </div>
        <div
            class="layout gap-2 d-flex:t"
            :class="[ canShare && $device.isMobile ? 'd-none' : 'd-flex p-t-2' ]">
          <div class="layout-item is-12 is-3:t">
            <a
                class="btn-secondary BTN-SOCIAL w-100"
                data-site="Email"
                :href="$options.SOCIAL_NETWORKS.mail.url + socialReferenceUrl"
                target="_blank"
                rel="noopener noreferrer"
                @click="shareClick"
                type="button">
              <vk-icon name="envelope" class="m-r-1" size="20" /> Email
            </a>
          </div>
          <div class="layout-item is-12 is-3:t">
            <a
                class="btn-secondary BTN-SOCIAL w-100"
                :href="$options.SOCIAL_NETWORKS.facebook.url + socialReferenceUrl"
                target="_blank"
                rel="noopener noreferrer"
                data-site="Facebook"
                @click="shareClick"
                type="button">
              <img :src="$options.SOCIAL_NETWORKS.facebook.image" class="m-r-1" /> Facebook
            </a>
          </div>
          <div class="layout-item is-12 is-3:t">
            <a
                class="btn-secondary BTN-SOCIAL w-100"
                :href="$options.SOCIAL_NETWORKS.twitter.url + socialReferenceUrl"
                target="_blank"
                data-site="Twitter"
                @click="shareClick"
                type="button">
              <img :src="$options.SOCIAL_NETWORKS.twitter.image" class="m-r-1" /> Twitter
            </a>
          </div>
          <div class="layout-item is-12 is-3:t">
            <a
                class="btn-secondary BTN-SOCIAL w-100"
                :href="$options.SOCIAL_NETWORKS.linkedin.url + socialReferenceUrl"
                target="_blank"
                rel="noopener noreferrer"
                data-site="linkedin"
                @click="shareClick"
                type="button">
              <img :src="$options.SOCIAL_NETWORKS.linkedin.image" class="m-r-1" /> LinkedIn
            </a>
          </div>
        </div>
        <div class="layout" :class=" {'d-none':!canShare && $device.isMobile}  ">
          <div class="layout-item is-12 m-t-4">
            <button
                class="btn w-100"
                type="button"
                @click="shareButton">
              Invite a Pro
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

const IMAGE = {
  image: require('./assets/invitePro.svg'),
  html: 'Invite a Pro',
};
const SOCIAL_TEXT = 'Check%20Out%20Pro%20Referral!';
const SOCIAL_NETWORKS = {
  facebook: {
    image: require('./assets/facebook.svg'),
    url: `https://www.facebook.com/sharer/sharer.php?quote=${SOCIAL_TEXT}&u=`,
    html: 'facebook share',
  },
  linkedin: {
    image: require('./assets/linkedin.svg'),
    url: `http://www.linkedin.com/shareArticle?summary=${SOCIAL_TEXT}&url=`,
    html: 'linkedin share',
  },
  mail: {
    image: require('./assets/linkedin.svg'),
    url: `mailto:?Subject=${SOCIAL_TEXT}&Body=${SOCIAL_TEXT}%0A`,
    html: 'mail share',
  },
  twitter: {
    image: require('./assets/twitter.svg'),
    url: `https://twitter.com/intent/tweet?text=${SOCIAL_TEXT}%0A`,
    html: 'twitter share',
  },
};
export default {
  name: 'invite-a-pro',
  data () {
    return {
      error: '',
      copied: false,
      canShare: true,
    };
  },
  computed: {
    ...mapGetters('user', ['userId']),
    referenceUrl () {
      return `${window.location.origin}/pro-homepage?source=Refer%20a%20Pro&referredById=${this.userId}`;
    },
    socialReferenceUrl () {
      return `${window.location.origin}/pro-homepage?source%3DRefer%20a%20Pro%26referredById%3D${this.userId}`;
    },
  },
  methods: {
    copy ($event) {
      if (!this.copied) { // This line prevents propagation
        this.$events.$emit(this.$events.INVITE_URL_CLICKED);
        navigator.clipboard.writeText(this.referenceUrl);
        this.copied = true;
        if ($event.target.nodeName === 'INPUT') {
          $event.target.select();
        }
        setTimeout(() => {
          this.copied = false;
        }, 1250);
      }
    },
    async shareButton () {
      const shareData = {
        title: 'Check Out Pro Referral',
        text: 'Check Out Pro Referral!',
        url: `${window.location.origin}/pro-homepage?source=Refer%20a%20Pro&26referredById=${this.userId}`,
      };
      try {
        await navigator.share(shareData);
        this.$events.$emit(this.$events.INVITE_SHARE_CLICKED, { socialNetwork: 'Web Share Api', success: true });
      } catch (error) {
        this.canShare = false;
        this.$events.$emit(this.$events.INVITE_SHARE_CLICKED, { socialNetwork: 'Web Share Api', success: false });
      }
    },
    shareClick ($event) {
      const { site } = $event.target.dataset;
      this.$events.$emit(this.$events.INVITE_SHARE_CLICKED, { socialNetwork: site });
    },
  },
  IMAGE,
  SOCIAL_NETWORKS,
};
</script>
<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";
  .TITLE {
      @include margin(3, 3);
      @include margin-left(-3);
      @include h3();
      font-weight: bold;
    }
  .IMAGE {
    max-height: 150px;
    @include desktop() {
      max-height: unset;
      width:80%;
    }
  }
  .BTN-SOCIAL {
    border: 2px solid black;
    border-radius: 2px;
    color: black;
    font-weight: 600;
    svg {
      color: $color-depot;
    }
  }
  .COPY-BUTTON {
    border: 2px solid $color-depot;
    background-color: white;
    color: $color-depot;
  }
  </style>
